module.exports = __webpack_public_path__ + "static/media/share.c96962e6.svg";